import {
    Box,
    TextField
} from '@mui/material';
import { styled } from '@mui/material/styles';

const Content = styled(Box)`
    display: flex;
    padding: 1%;
    flex-wrap: wrap;
    justify-content: center;
`;

const Campo = styled(TextField)`
    margin: 1vh 0 1vh 0;
`;

export { Content, Campo };